"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDirectAnswer = void 0;
const ResultsFactory_1 = require("./ResultsFactory");
function createDirectAnswer(data) {
    return Object.freeze({
        relatedResult: ResultsFactory_1.ResultsFactory.fromDirectAnswer(data.relatedItem.data),
        verticalKey: data.relatedItem.verticalConfigId,
        entityName: data.answer.entityName,
        fieldName: data.answer.fieldName,
        fieldApiName: data.answer.fieldApiName,
        value: data.answer.value,
        fieldType: data.answer.fieldType
    });
}
exports.createDirectAnswer = createDirectAnswer;
